import { Box, Flex, Icon } from '@chakra-ui/react';
import { CheckIcon } from '@chakra-ui/icons';
import { useMemo } from 'react';

export type OrderStatus = 'completed' | 'in-progress' | 'in-review' | 'manually-flagged' | 'not-started' | 'archived' | 'unknown';

export const getStatusColor = (status: OrderStatus) => {
    switch (status) {
        case 'completed': return '#2F855A'; //green.500
        case 'in-progress': return '#ECC94B'; // Yellow.400
        case 'in-review': return '#42A5F5'; // blue.400
        case 'manually-flagged': return '#ED8936'; // Orange.400
        case 'not-started': return '#0071E3'; // PartBay blue
        case 'archived': return '#8B98AB'; // Gray.400
        default: return '#A0AEC0';
    }
};

export const getStatusLabel = (status: OrderStatus) => {
    switch (status) {
        case 'completed': return 'Completed';
        case 'in-progress': return 'In Progress';
        case 'in-review': return 'In Review';
        case 'manually-flagged': return 'Saved for Later';
        case 'not-started': return 'Not Started';
        case 'archived': return 'Archived';
        default: return 'Unknown';
    }
};

interface StatusIconProps {
    status: OrderStatus;
    size?: string;
}

const StatusIcon = ({ status, size = '16px' }: StatusIconProps) => {
    const color = useMemo(() => getStatusColor(status), [status]);

    if (status === 'completed') {
        return (
            <Flex
                w={size}
                h={size}
                borderRadius="full"
                bg={color}
                align="center"
                justify="center"
            >
                <Icon as={CheckIcon} w="8px" h="8px" color="white" />
            </Flex>
        );
    }

    // in-progress, in-review, manually-flagged, not-started - show dot
    return (
        <Flex
            w={size}
            h={size}
            borderRadius="full"
            border="2px solid"
            borderColor={color}
            bg="white"
            align="center"
            justify="center"
        >
            <Box
                w="50%"
                h="50%"
                borderRadius="full"
                bg={color}
            />
        </Flex>
    );
};

export default StatusIcon;

